import React, { useCallback } from "react";
import { InfoWindow } from "@react-google-maps/api";
import StarRating from "../../../StarRating/starrating";
import { useSearch } from "../../../../contexts/SearchContext";
import { useNavigate } from "react-router-dom";

const HotelInfoWindow = ({ hotel, position, onClose }) => {
  const { getSearchPhrase, sessionId } = useSearch();
  const navigate = useNavigate();

  const navigaeToHotelsProfile = useCallback(async () => {
    const searchPhrase = await getSearchPhrase;

    // Gather data
    let data = {
      hotelID: hotel.ID,
      session: sessionId,
      checkIn: searchPhrase.checkIn,
      checkOut: searchPhrase.checkOut,
      rooms: searchPhrase.rooms,
    };

    // Save in the local storage the new data
    localStorage.setItem("currentSearchPhrase", JSON.stringify(data));

    // Open the link in a new tab
    navigate("/hotelprofile/" + hotel.ID);
  }, [getSearchPhrase, sessionId, navigate, hotel]);

  if (!hotel) return null;
  return (
    <InfoWindow
      position={position}
      onCloseClick={onClose}
      options={{
        pixelOffset: new window.google.maps.Size(0, -30),
        maxWidth: 300,
      }}
    >
      <div className="tw-p-2 tw-max-w-[280px]">
        <div className="tw-flex tw-flex-col tw-gap-2">
          {/* Hotel image */}
          {hotel.DefaultImage?.FullSize && (
            <div className="tw-w-full tw-h-[120px] tw-overflow-hidden tw-rounded">
              <img
                src={hotel.DefaultImage.FullSize}
                alt={hotel.DisplayName}
                className="tw-w-full tw-h-full tw-object-cover"
              />
            </div>
          )}

          {/* Hotel info */}
          <div>
            <div className="tw-mb-1">
              <StarRating rating={hotel.StarRating} />
            </div>

            <h3 className="tw-font-semibold tw-text-base tw-mb-1">
              {hotel.DisplayName}
            </h3>

            <div className="tw-text-sm tw-mb-2 tw-text-gray-600">
              {hotel.Address}
            </div>

            {hotel.distance && (
              <div className="tw-text-xs tw-mb-1">
                {hotel.distance.toFixed(2)} ק"מ מהיעד
              </div>
            )}

            {/* Price info */}
            {hotel.LowestPackagePrice && (
              <div className="tw-flex tw-items-center tw-justify-between tw-mt-2">
                <div className="tw-text-sm tw-font-medium">החל מ:</div>
                <div className="tw-text-lg tw-font-bold tw-text-green-600">
                  ₪{hotel.LowestPackagePrice.toFixed(2)}
                </div>
              </div>
            )}

            {/* View details button */}
            <button
              className="tw-mt-2 tw-w-full tw-py-1 tw-px-3 tw-bg-blue-600 tw-text-white tw-rounded tw-text-sm hover:tw-bg-blue-700 tw-transition-colors"
              onClick={() => {
                navigaeToHotelsProfile();
              }}
            >
              לפרטים נוספים
            </button>
          </div>
        </div>
      </div>
    </InfoWindow>
  );
};

export default HotelInfoWindow;
